
import React, { useEffect, useState } from "react";
import {
  Box,
  CssBaseline,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Routes, Route, useNavigate } from "react-router-dom";
import Sidebar from "../SideNav/Sidebar";
import Header from "../SideNav/Header";
import Dashboard from "../../Pages/Admin/Dashboard/Dashboard";
import Designation from "../../Pages/Admin/Master/Designation/Designation";
import Departments from "../../Pages/Admin/Master/Departments/Departments";
import SubDepartment from "../../Pages/Admin/Master/SubDepartment/SubDepartment";
import KraKpi from "../../Pages/Admin/Master/KraKpi/KraKpi";
import YearOfDuration from "../../Pages/Admin/Master/YearOfDuration/YearOfDuration";
import AddEmployee from "../../Pages/Admin/UserManagement/AddEmployee/AddEmployee";
import EmpoloyeeDetails from "../../Pages/Admin/UserManagement/AddEmployee/EmpoloyeeDetails";
import KrapKpiManagement from "../../Pages/Admin/KrapKpiManagement/KrapKpiManagement";
import KrapKpiManagementHomePage from "../../Pages/Admin/KrapKpiManagement/KrapKpiManagementHomePage";
import OverviewReports from "../../Pages/Admin/Reports/OverviewReports";
import KrapKpiManagemenEdit from "../../Pages/Admin/KrapKpiManagement/KrapKpiManagemenEdit";
import BellCurveMainPage from "../../Pages/Admin/Reports/BellCurveMainPage";
import EmployeePdfUpload from "../../Pages/Admin/UserManagement/EmployeePdfUpload/EmployeePdfUpload";
import PmsScoreEnable from "../../Pages/Admin/Reports/PmsScoreEnable";
import BrandingSettings from "../CustomSettings/CustomSetttings";
import MailSettings from "../../Pages/Admin/Settings/MailSettings";
import UsersSync from "../../Pages/Admin/Settings/UsersSync";
import Footer from "../Footer/Footer";

// import AboutUsManagementAboutUsContentManagement from "../../Pages/ContentManagement/AboutUs/AboutUsContentManagement";
// import SchemeApprovalTabs from "../../Pages/Management/SchemeApproval/SchemeApprovalTabs";

const Layout = ({ dynamicLogo }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // const { isLoggedIn, permissions, role } = useSelector((state) => state.auth);
  const [headerTitleName, setHeaderTitleName] = useState("");
  const handleMenuClick = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const role = sessionStorage.getItem("role")
  console.log(role, "roleeeeeeeee");

  const navigate = useNavigate()
  useEffect(() => {
    if (role !== 'admin') {
      navigate('/');
    }
  }, []);


  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        padding: { md: 1.5 },
        backgroundColor: "#F7F7F7",
      }}
    >
      <CssBaseline />
      {/* <Sidebar open={isSidebarOpen} onClose={() => setSidebarOpen(false)} /> */}
      <Sidebar open={isSidebarOpen} onClose={() => setSidebarOpen(false)} dynamicLogo={dynamicLogo} />
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        <Header
          userRole="Admin"
          logoutRouterName="/"
          headerTitleName={headerTitleName}
          onMenuClick={handleMenuClick}
          isMobile={isMobile}
          isSidebarOpen={isSidebarOpen}
        />
        <Box
          component="main"
          sx={{ flexGrow: 1, p: 2.5, backgroundColor: "#F7F7F7" }}
        >
          {/* <Typography variant='hello'>hello</Typography> */}

          <Routes>

            <Route path="/" element={<Dashboard />} />
            <Route path="designation" element={<Designation />} />
            <Route path="department" element={<Departments />} />
            <Route path="subdepartment" element={<SubDepartment />} />
            <Route path="krakpi" element={<KraKpi />} />
            <Route path="yearofdappraisal" element={<YearOfDuration />} />
            <Route path="addemployee" element={<AddEmployee />} />
            <Route path="employeedetails" element={<EmpoloyeeDetails />} />
            <Route path="rolewisekrakpi" element={<KrapKpiManagementHomePage />} />
            <Route path="createkrakpi" element={<KrapKpiManagement />} />
            <Route path="overviewreports" element={<OverviewReports dynamicLogo={dynamicLogo} />} />
            <Route path="editkrakpi/:id" element={<KrapKpiManagemenEdit />} />
            <Route path="bellcurvereports" element={<BellCurveMainPage />} />
            <Route path="employeepdfupload" element={<EmployeePdfUpload />} />
            <Route path="pmsscoreenable" element={<PmsScoreEnable />} />
            <Route path="sitesettings" element={<BrandingSettings />} />
            <Route path="mailsettings" element={<MailSettings />} />
            <Route path="userssync" element={<UsersSync />} />














          </Routes>
        </Box>
        <Footer />

      </Box>
    </Box>
  );
};

export default Layout;
